export default __webpack_public_path__ + "static/media/yotta21-OTTA.ba58cc62.png";